export default __webpack_public_path__ + "static/media/profilepic.fe350fe3.jpg";